import { PaymentMethodInputTypes } from '@/utils/constants'
import { atom } from 'jotai'
import { atomWithStorage } from 'jotai/utils'

export const payments: PaymentMethod[] = [
  { id: 1, label: 'Google Pay', type: 'google_pay', icon: '/Payment/GooglePay.svg', short: 'GP' },
  { id: 2, label: 'Visa ****1343', type: 'card', icon: '/Payment/Visa.svg', short: 'Visa *1343' },
  { id: 3, label: 'Visa ****2344', type: 'card', icon: '/Payment/Visa.svg', short: 'Visa *2344' },
  { id: 4, label: 'Mastercard ****2344', type: 'card', icon: '/Payment/MasterCard.svg', short: 'MC *2344' },
]
export const paymentsMethodModalAtom = atom<boolean>(false)
export const PaymentDataAtom = atom<PaymentData | null>(null)

export const switchedPaymentMethodAtom = atomWithStorage<boolean>('switchedPaymentMethod', false)

export enum CardAuthRequestTypes {
  CHECKIN = 'CHECKIN',
  SUBMIT_ORDER = 'SUBMIT_ORDER',
  PAYMENT = 'PAYMENT',
}

export const cardAuthRequestTypeAtom = atom<CardAuthRequestTypes | undefined>(undefined)

export const retryCardAuthAtom = atom<boolean>(false)

export interface PaymentMethod {
  id: number
  label: string
  type: string
  icon: string
  short: string
}

export interface PaymentData {
  network?: string
  name: string
  pan_mask: string
  input_mode: PaymentMethodInputTypes
  card_token: string
  expiration?: string
}

export interface PaymentMethodData {
  description: string
  tokenizationData: TokenizationData
  type: string
  info: Info
}

export interface TokenizationData {
  type: string
  token: string
}

export interface Info {
  cardNetwork: string
  cardDetails: string
}
